import React,{Component} from 'react';
import Alert from 'react-s-alert';
import Modal from 'react-modal';
import firebase from 'firebase';
import { GoogleMap, withGoogleMap, withScriptjs, Marker } from 'react-google-maps'
import SearchBox from 'react-google-maps/lib/components/places/SearchBox'



const database=firebase.database();

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    transform             : 'translate(-50%, -50%)',
	width                 : '450px'
	
  }
};


class ModalBases extends Component{
	
	constructor(props){
		
		super(props);
		this.state={
			baseKey:'',
			nombre:'',
			description:'',
			foto:'',
			latitud:'',
			longitud:'',
			direccion:'',
			isActive:false,
			files:null,
			uploadValue:0,
		}
		
		this.basesRef=database.ref().child('Bases');
		
		this.toggleModal=this.toggleModal.bind(this);
		this.handleUpload=this.handleUpload.bind(this);
		this.submitInsert=this.submitInsert.bind(this);
	}
	
	
	toggleModal(){		
		this.setState({			
			foto:'',
			files:null,
			isActive:!this.state.isActive			
		});
	}
	
	submitInsert(event){
		
		
		let nombre=this.nombreBase.value;
		let descripcion=this.descripcionBase.value;
		let direccion=this.direccionBase.value;
		let latitud=0;
		let longitud=0;
		let foto='';
		
		//Archivo de la imagen
		let archivo=this.state.files;
		
		const storageRef = firebase.storage().ref(`Bases/${archivo.name}`);
		
		const task= storageRef.put(archivo);
		
		task.on('state_changed', snapshot =>{
		
		
		this.setState({
		  uploadValue :50,
		})

		}, error =>{ console.log(error.message);
		},
		()=>{
			


			this.basesRef.push({
			
					Descripcion:descripcion,
					Nombre:nombre,
					latitud:latitud,
					longitud:longitud,
					foto:task.snapshot.downloadURL,
					direccion:direccion
			});	
	
			
			this.setState({
				uploadValue:100,
				urlFoto:task.snapshot.downloadURL
			});
			
			this.toggleModal();
			
			Alert.success('Datos guardados correctamente', {
				effect: 'genie',
				position: 'bottom-right',
				timeout:2000			
			});
			 

		});
		
		
		
		
		event.preventDefault();
	}
	
	handleUpload(e,filee){
		
		var file= e.target.files[0],
		pattern= /image-*/,
		reader=new FileReader();
		
		if(file===undefined){
			
			this.setState({ 
				 foto:null,
				 files:null
			}); 
			
		}
		else{
			
			if(!file.type.match(pattern)){
			
					Alert.error('Por favor ingresa una imagen con formato valido', {
						effect: 'genie',
						position: 'bottom-right',
						timeout:2000			
					});
					return;
				}
		


				reader.onload = (e) => {
					this.setState({ 
						foto:reader.result,
						files:file
					}); 
				}		
			
				reader.readAsDataURL(file);			
		}
	}
	
	render(){
		return(
			
				<div className="modal_bases">
					<button className="btn btn-primary" onClick={this.toggleModal}><span className="glyphicon glyphicon-plus"> </span> Nuevo</button>
		
					<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal}  style={customStyles}>
					
						<h3>Agregar Base</h3>
						
						<form method="POST" action="" onSubmit={this.submitInsert}>
							
							<div className="form-group">
								<label htmlFor="nombre">Nombre:</label>
								<input type="text" className="form-control" placeholder="Nombre"
								ref={input =>{this.nombreBase=input;}}
								required autoComplete="off" 
								defaultValue={this.state.nombre}
								/>
							</div>
							
							<div className="form-group">
								<label htmlFor="descripcion">Descripcion:</label>
								<textarea className="form-control" name="descripcion" placeholder="Descripcion"
								ref={input=>{this.descripcionBase=input;}} autoComplete="off"
								defaultValue={this.state.descripcion}								
								></textarea>
							</div>
							<div className="form-group">
								<label htmlFor="direccion">Direccion:</label>
								<textarea className="form-control" name="direccion" placeholder="Direccion"
								ref={input=>{this.direccionBase=input;}} autoComplete="off"
								defaultValue={this.state.direccion}								
								></textarea>
							</div>
							
							<div className="form-group">
										<label htmlFor="foto">Foto de la base</label>
										<br/>
										<progress value={this.state.uploadValue} max="100"></progress>
										<input type="file" className="form-control"  onChange={this.handleUpload} required/>
							</div>
							<img src={this.state.foto} alt="Foto base" className="foto" width="240px"/>
							
							<button type="submit" className="btn btn-primary buttons" >Guardar</button>
						</form>
							<button type="button" className="btn btn-default buttons  btnmargin" onClick={this.toggleModal}>Cerrar</button>
					
					</Modal>
		
				</div>
		
		
		);
		
	}
	
}

export default ModalBases;


// WEBPACK FOOTER //
// ./src/Components/Bases/ModalBases.js